import React, { useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../../LayoutWrapper/AdminLayout";
import { useTranslation } from "react-i18next";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import "../../CSS/HelpSupport/modern.css";

const FAQ_IDS = ["faq-1", "faq-2", "faq-3", "faq-4"];

const HelpSupport = () => {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState(FAQ_IDS[0]);

  const toggleFaq = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <AdminLayout>
      <div className="help-page">
        <section className="help-hero">
          <div className="help-hero__inner">
            <span className="help-hero__badge">
              <HelpOutlineIcon sx={{ fontSize: 18 }} />
              {t("HELP_SUPPORT")}
            </span>
            <h1 className="help-hero__title">{t("page_title_help_support")}</h1>
          </div>
        </section>

        <section className="help-main">
          <div className="help-main__inner">
            <header className="help-main__header">
              <p className="help-main__label">Frequently asked questions</p>
              <h2 className="help-main__title">{t("HELP_SUPPORT")}</h2>
              <p className="help-main__subtitle">{t("help_support_subtitle1")}</p>
            </header>

            <div className="help-faq" role="list">
              {FAQ_IDS.map((id) => {
                const isOpen = openId === id;
                return (
                  <article
                    key={id}
                    className={`help-faq__item${isOpen ? " help-faq__item--open" : ""}`}
                    role="listitem"
                  >
                    <button
                      type="button"
                      className="help-faq__trigger"
                      onClick={() => toggleFaq(id)}
                      aria-expanded={isOpen}
                    >
                      <span className="help-faq__question">
                        <span className="help-faq__question-icon">
                          <QuestionAnswerOutlinedIcon fontSize="small" />
                        </span>
                        <span className="help-faq__question-text">
                          {t("help_support_ques1")}
                        </span>
                      </span>
                      <ExpandMoreIcon className="help-faq__chevron" />
                    </button>
                    <div className="help-faq__panel" aria-hidden={!isOpen}>
                      <p className="help-faq__answer">{t("help_support_ans1")}</p>
                    </div>
                  </article>
                );
              })}
            </div>

            <div className="help-cta">
              <h3 className="help-cta__title">Still need help?</h3>
              <p className="help-cta__text">
                Our team is ready to assist you with bookings, driver questions, and more.
              </p>
              <Link to="/contact" className="help-cta__btn">
                <ContactSupportOutlinedIcon fontSize="small" />
                Contact us
                <ArrowForwardIcon fontSize="small" />
              </Link>
            </div>
          </div>
        </section>
      </div>
    </AdminLayout>
  );
};

export default HelpSupport;
